import type { CanonicalDataType } from "@/shared/domain/topics";
import {
  ALL_COLUMNS_ID,
  LOG_TIME_ID,
} from "@/shared/state/visualization/schema/v1/log-panel";

export interface ColumnDefinition {
  /**
   * Logical key the value is stored under in `Log.data`. For a real column this
   * is the message-path name, so the same signal from several files shares one
   * `columnId`; for synthetic columns it's a sentinel ({@link ALL_COLUMNS_ID} /
   * {@link LOG_TIME_ID}). Not a per-file message-path id.
   */
  columnId: string;
  name: string;
  /**
   * Underlying per-file message-path ids (one per contributing file). Used to
   * add/remove the panel-data entries, which are keyed by message-path id.
   * Absent for synthetic columns.
   */
  messagePathIds?: string[];
  dataType?: CanonicalDataType;
  // When the column is categorical, the ordered list of category labels
  // (index → label). Used by Row to render e.g. "3 (Configured)".
  categories?: string[];
}

// The synthetic column IDs live in the schema layer (they are persisted
// filter-map keys); re-exported here so panel code keeps one import site.
export { ALL_COLUMNS_ID, LOG_TIME_ID };

/**
 * Display name for the synthetic "All columns" filter entry.
 */
export const ALL_COLUMNS_NAME = "All columns";

/**
 * Display name for the built-in log timestamp filter entry.
 */
export const LOG_TIME_NAME = "Log time";
